import _getVideoUrl from '@wix/communities-blog-universal/dist/src/utils/media/video';
export var getVideoUrl = function (_a) {
    var pathname = _a.pathname, videoHost = _a.videoHost;
    return _getVideoUrl(videoHost)(pathname);
};
